import { z } from 'zod';

export const DocType = z.enum(['quote', 'order', 'job', 'spool']);
export type DocType = z.infer<typeof DocType>;

export const DOC_TYPE_LABELS: Record<DocType, string> = {
  quote: 'Orçamentos',
  order: 'Pedidos',
  job: 'Impressões',
  spool: 'Carretéis',
};

/** `Q-2026-0045` / `J-0218`: prefix, optional year, 4-digit sequence. */
export function formatDocNumber(prefix: string, year: number | null, value: number): string {
  const seq = String(value).padStart(4, '0');
  return year === null ? `${prefix}-${seq}` : `${prefix}-${year}-${seq}`;
}

export const NumberSequence = z.object({
  docType: DocType,
  prefix: z.string(),
  withYear: z.boolean(),
  resetYearly: z.boolean(),
  nextValue: z.number().int(),
  nextNumber: z.string().describe('What the next document will be numbered.'),
});
export type NumberSequence = z.infer<typeof NumberSequence>;

export const NumberingList = z.object({ data: z.array(NumberSequence) });

export const UpdateNumberingBody = z.object({
  items: z
    .array(
      z
        .object({
          docType: DocType,
          prefix: z
            .string()
            .trim()
            .toUpperCase()
            .regex(/^[A-Z]{1,4}$/, '1 to 4 letters'),
          withYear: z.boolean(),
          resetYearly: z.boolean(),
          nextValue: z.number().int().min(1).max(9_999_999),
        })
        .refine(
          (i) => i.withYear || !i.resetYearly,
          '"Zerar todo ano" needs the year in the number',
        ),
    )
    .min(1),
});
export type UpdateNumberingBody = z.input<typeof UpdateNumberingBody>;
